module.exports = __webpack_public_path__ + "img/neotag-product5.ab2f390b.jpg";